export default "__VITE_ASSET__e0d8729a__"